import { SUBSCRIPTIONS_API_KEYS } from "features/MySubscriptions/constants/MySubscriptions.constants";
import { dedupeTenurePlans } from "features/MySubscriptions/utils/normalizeSubscriptionPlansResponse";

export const getAccessTypeTenurePlansFromApiResponse = (response) => {
  const [subscriptionPlan] = response?.data?.data?.subscription_plans ?? [];

  return dedupeTenurePlans(
    subscriptionPlan?.[SUBSCRIPTIONS_API_KEYS.plans] ?? []
  );
};
